import React from "react";

const Icon2: React.FC = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="28"
      height="27"
      fill="transparent"
      viewBox="0 0 28 27"
    >
      <path
        fill="currentColor"
        d="M14 12.107a6.667 6.667 0 016.666 6.666v8H18v-8a4 4 0 00-3.765-3.993L14 14.774a4 4 0 00-3.993 3.765l-.007.234v8H7.333v-8A6.667 6.667 0 0114 12.107zm-8.667 4c.372 0 .733.044 1.08.125a7.93 7.93 0 00-.401 2.1L6 18.773v.115a1.996 1.996 0 00-.475-.107l-.192-.008a2 2 0 00-1.99 1.807l-.01.194v6H.667v-6a4.667 4.667 0 014.666-4.667zm17.334 0a4.666 4.666 0 014.666 4.666v6h-2.666v-6a2 2 0 00-1.807-1.99l-.194-.01c-.233 0-.457.04-.666.114v-.114a7.99 7.99 0 00-.41-2.538 4.548 4.548 0 011.076-.128zm-17.334-8a3.333 3.333 0 110 6.667 3.333 3.333 0 010-6.667zm17.334 0a3.333 3.333 0 110 6.666 3.333 3.333 0 010-6.666zM5.332 10.774a.667.667 0 100 1.333.667.667 0 000-1.333zm17.334 0a.667.667 0 100 1.333.667.667 0 000-1.333zM14 .107a5.333 5.333 0 110 10.667A5.333 5.333 0 0114 .107zm0 2.667a2.667 2.667 0 100 5.333 2.667 2.667 0 000-5.333z"
      ></path>
    </svg>
  );
}

export default Icon2;
